<template>
    <div>
        <v-main>           
            <navBar title="Ares - Customer Success" :home="true" type="customersuccess" goto="/task/customer_success/mnCustomerSuccess" />
            <v-container fluid class="ma-4">
              <v-row dense >
                <v-col cols="2">
                  <v-text-field
                    v-model="huovcode"
                    label="Booking Number"
                    dense
                    clearable
                  />
                </v-col>
                <v-col cols="1" class="mt-2 ml-3">and / or</v-col>
              </v-row>
              <v-row dense >
                <v-col cols="3">
                  <v-text-field
                    v-model="email"
                    label="E-mail Address"
                    dense
                    clearable
                  />
                </v-col>
                <v-col cols="3">
                  <v-btn
                    :loading="loading"
                    small
                    color="primary"
                    @click="getLgcdCodes()"
                    class="ml-2"
                  >
                    Search
                  </v-btn>
                </v-col>  
              </v-row>
            <v-row v-if="this.codes.length !==0" class="ml-0 mb-1 mt-4">
              Found {{ codes.length }} code(s)
            </v-row>    
            <v-row v-else class="ml-0 mb-1 mt-4">No codes found</v-row>
            <v-row>
            <v-simple-table>
              <template v-slot:default>
               <tbody>
                <tr v-for="(code,i) in codes" :key="i">
                <td style="font-weight: bold; font-size: 1em;">{{ code.code }}</td>
                 <td>{{ code.huovcode }}</td>
                 <td>{{ code.email }}</td>
                 <td>{{ $moment(code.created).format('DD-MM-YYYY HH:mm') }}</td>
                <td>
                  <v-icon :color="code.valid ? 'green' : 'red'">
                    {{ code.valid ? 'mdi-check-circle' : 'mdi-close-circle' }}
                  </v-icon>
                </td>
                <td>
                  <span v-if="code.valid">{{ code.validity }} mins.</span>
                  <span v-else>Expired</span>
                </td>
                </tr>                  
               </tbody>  
              </template>  
            </v-simple-table>  
            </v-row>
            </v-container>
        </v-main>
    </div>
</template>

<script>
    
    import navBar from "@/components/ui/navbars/navbar.vue";

    export default {        

        components: {
          navBar,
        },
        destroyed() {
        },              
        mounted() {
        },             
        data() {
            return {      
                test: '',
                loading: false,
                huovcode: '',
                email: '',
                codes: []
            }
        },    
        methods: {
          getLgcdCodes() {
            this.loading = true;
            this.$axios
              .post("ares/json/ares/task/customer_success/lgcd/getLgcd.p", {
                header: {
                  token: this.$session.get("ARES"),
                  clientSessionId: this.$session.id(),
                  request: "getLgcd"
                },
                getLgcd: {
                  huovcode: this.huovcode,
                  email: this.email
                }
              })
              .then(res => {
                if (res.data.error) {
                  console.log(res.data.error);
                  this.codes = []
                  this.loading = false;
                } else {
                  console.log(res.data.getLgcd);
                  this.codes = res.data.getLgcd;
                  this.loading = false;
                }
              });
          }
        },           
    }
</script>

<style scoped>


</style>
